import { Component, effect, input, output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { ListComponent } from '../list/list.component';
import { Types } from 'shared-lib';
import { EComponentSize, EIcon } from '../../types';

@Component({
  selector: 'ui-pagination',
  standalone: true,
  imports: [IconComponent, ListComponent],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.css',
})
export class PaginationComponent {
  total = input(1);
  current = input(1);
  refresh = output<number>();

  pages: number[] = [];

  itemsPerPage: Types.EItemsPerPage = Types.EItemsPerPage.Ten;
  Options = Object.values(Types.EItemsPerPage).filter(value => typeof value === 'number');
  itemsPerPageChange = output<number>();
  EIcon = EIcon;
  EComponentSize = EComponentSize;
  EAlert = Types.EAlert;
  EList = Types.EList;
  
  constructor() {
    effect(() => {
      this.pages = Array(this.total())
        .fill(this.total(), 0, this.total())
        .map((x, i) => i + 1);
    });
  }

  goTo(page: number) {
    this.refresh.emit(page);
  }

  goNext() {
    if (this.current() < this.total()) {
      this.refresh.emit(this.current() + 1);
    }
  }

  goBefore() {
    if (this.current() > 1) {
      this.refresh.emit(this.current() - 1);
    }
  }

  onItemsPerPageChange(value: any) {
    this.itemsPerPage = value as Types.EItemsPerPage;
    this.itemsPerPageChange.emit(value);
  }
}
